export default element => element && (element.scrollHeight > element.clientHeight);
